"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingData = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var record_1 = require("../../model/record");
var service_1 = require("../../../library/base/service");
var TradingData = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(TradingData, _super);
    function TradingData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '交易记录接口';
        _this.code = '101047';
        _this.desc = '交易记录接口';
        _this.requestParams = new record_1.TradingDataRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return TradingData;
}(service_1.BaseService));
exports.TradingData = TradingData;
//# sourceMappingURL=tradingData.js.map